<template>
    <ul :class="navbarClass">
        <li v-for="(ml,mlKey) in menuList" :key="'ml'+mlKey" class="nav-item"
            :class="ml.children ? 'dropdown' : ''">
            <a class="dropdown-toggle nav-link" data-toggle="dropdown" role="button" href="#"
                v-if="ml.children">
                <font-awesome-icon :size="iconSize" :icon="ml.icon" v-if="ml.icon.length > 0" :spin="ml.iconSpin"></font-awesome-icon>
                <div v-if="iconPosition == 'top'"></div>
                {{ ml.title }}
            </a>
            <router-link class="nav-link" :to="{ name : ml.key }" v-else @click.native="routerClicked()">
                <font-awesome-icon :size="iconSize" :icon="ml.icon" v-if="ml.icon.length > 0" :spin="ml.iconSpin"></font-awesome-icon>
                <div v-if="iconPosition == 'top'"></div>
                {{ ml.title }}
            </router-link>
            <ul class="p-0 shadow dropdown-menu" v-if="ml.children">
                <li v-for="(mlc,mlcKey) in ml.children" :key="'mlc'+mlcKey">
                    <router-link :to="{ name: mlc.key }" class="dropdown-item" @click.native="routerClicked()">
                    <font-awesome-icon :icon="mlc.icon" v-if="mlc.icon.length > 0"></font-awesome-icon>
                    {{ mlc.title }}
                    </router-link>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
// @modified: change uri to key
// @version V0.0.3 [Saturday - 20201114_202517] : change children length - if, change label -> title
// @version V0.0.2 [Monday - 20200831_164616] : add iconSpin, iconSize, iconPosition, navbarClass
// @version V0.0.1 [Sunday - 20200830_112256] : init

    export default {
        name: "NavbarMenuList",
        data() {
            return {};
        },
        methods: {
            routerClicked() {
                this.$emit('routerClicked');
            }
        },
        props : {
            menuList : Array,
            navbarClass : {
                type : String,
                default : 'navbar-nav mr-auto'
            },
            iconSize : {
                type : String,
                default: '1x' // font awesome size xs,lg,sm,1x-10x
            },
            iconPosition : {
                type : String,
                default : 'inline' // inline, top
            }
        }
    };

</script>

<style lang="css" scoped>
</style>
